import { QuestionMark } from '@mui/icons-material'
import { useTheme } from '@mui/material'

export const SignalIcon = ({
  value,
  isOffline,
  htmlColor: _htmlColor,
  'aria-label': ariaLabel,
  ...props
}: {
  value: number
  isOffline: boolean
  htmlColor?: string
  'aria-label': string
}) => {
  const theme = useTheme()
  let bar1Color = 'black'
  let bar2Color = 'black'
  let bar3Color = 'black'
  let bar4Color = 'black'
  let bar5Color = 'black'
  switch (value) {
    case 1:
      bar1Color = theme.palette.error.main
      break
    case 2:
      bar1Color = theme.palette.warning.light
      bar2Color = theme.palette.warning.light
      break
    case 3:
      bar1Color = theme.palette.success.light
      bar2Color = theme.palette.success.light
      bar3Color = theme.palette.success.light
      break
    case 4:
      bar1Color = theme.palette.success.light
      bar2Color = theme.palette.success.light
      bar3Color = theme.palette.success.light
      bar4Color = theme.palette.success.light
      break
    case 5:
      bar1Color = theme.palette.success.light
      bar2Color = theme.palette.success.light
      bar3Color = theme.palette.success.light
      bar4Color = theme.palette.success.light
      bar5Color = theme.palette.success.light
      break
    default:
      break
  }
  if (isOffline) {
    bar1Color = theme.palette.divider
    bar2Color = theme.palette.divider
    bar3Color = theme.palette.divider
    bar4Color = theme.palette.divider
    bar5Color = theme.palette.divider
  }

  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel}>
      <path
        d="M2.52632 12.5C2.52632 12.2239 2.30246 12 2.02632 12H0.5C0.223858 12 0 12.2239 0 12.5V15.5C0 15.7761 0.223858 16 0.5 16H2.02632C2.30246 16 2.52632 15.7761 2.52632 15.5V12.5Z"
        fill={bar1Color}
        fillOpacity="1"
      />
      <path
        d="M3.36842 9.5C3.36842 9.22386 3.59228 9 3.86842 9H5.39474C5.67088 9 5.89474 9.22386 5.89474 9.5V15.5C5.89474 15.7761 5.67088 16 5.39474 16H3.86842C3.59228 16 3.36842 15.7761 3.36842 15.5V9.5Z"
        fill={bar2Color}
        fillOpacity={value === 1 && !isOffline ? 0.12 : 1}
      />
      <path
        d="M9.26362 6.5C9.26362 6.22386 9.03976 6 8.76362 6H7.2373C6.96116 6 6.7373 6.22386 6.7373 6.5V15.5C6.7373 15.7761 6.96116 16 7.23731 16H8.76362C9.03976 16 9.26362 15.7761 9.26362 15.5V6.5Z"
        fill={bar3Color}
        fillOpacity={value < 3 && !isOffline ? 0.12 : 1}
      />

      <path
        d="M12.632 3.5C12.632 3.22386 12.4082 3 12.132 3H10.6057C10.3296 3 10.1057 3.22386 10.1057 3.5V15.5C10.1057 15.7761 10.3296 16 10.6057 16H12.132C12.4082 16 12.632 15.7761 12.632 15.5V3.5Z"
        fill={bar4Color}
        fillOpacity={value < 4 && !isOffline ? 0.12 : 1}
      />

      <path
        d="M16.0009 0.5C16.0009 0.223858 15.7771 0 15.5009 0H13.9746C13.6985 0 13.4746 0.223858 13.4746 0.5V15.5C13.4746 15.7761 13.6985 16 13.9746 16H15.5009C15.7771 16 16.0009 15.7761 16.0009 15.5V0.5Z"
        fill={bar5Color}
        fillOpacity={value < 5 && !isOffline ? 0.12 : 1}
      />
    </svg>
  )
}

export const NoSignalIcon = ({ isOffline, 'aria-label': ariaLabel, ...props }: { isOffline: boolean; 'aria-label': string }) => {
  const theme = useTheme()
  return (
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9997 4H17.4734V12.0274C17.6465 12.0093 17.8222 12 18 12C18.711 12 19.3873 12.1484 19.9997 12.4159V4ZM13.2629 15.3958C13.0924 15.8993 13 16.4389 13 17C13 17.5611 13.0924 18.1007 13.2629 18.6042V20H10.7366V10H13.2629V15.3958ZM16.6313 12.1896C15.6234 12.4759 14.7452 13.0703 14.105 13.8646V7H16.6313V12.1896ZM9.89448 13H7.36816V20H9.89448V13ZM4 16H6.52632V20H4V16Z"
        fill="black"
        fillOpacity="0.12"
      />
      <path
        d="M19.7949 20L21 18.7949L19.1924 16.9958L21 15.1966L19.7949 14L17.9958 15.7992L16.1966 14L15 15.1966L16.7992 16.9958L15 18.7949L16.1966 20L17.9958 18.1924L19.7949 20Z"
        fill={isOffline ? theme.palette.divider : '#B00020'}
      />
    </svg>
  )
}

export const EthernetIcon = ({ isOffline, 'aria-label': ariaLabel, ...props }: { isOffline: boolean; 'aria-label': string }) => {
  const theme = useTheme()
  const fillColor = isOffline ? theme.palette.divider : theme.palette.success.light
  return (
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel}>
      <path
        d="M14.1336 19.9996H9.9336C9.5336 19.9996 9.2672 19.6831 9.2672 19.2078V17.4655L7.0664 17.4646C6.6664 17.4646 6.4 17.1481 6.4 16.6728V14.6929L4.6664 14.692C4.2664 14.692 4 14.3754 4 13.9002C4 13.4249 4.2664 13.1084 4.6664 13.1084H7.0664C7.4664 13.1084 7.7328 13.4249 7.7328 13.9002V15.8801H9.9328C10.3328 15.8801 10.5992 16.1966 10.5992 16.6719V18.4142H13.4656V16.6719C13.4656 16.1966 13.732 15.8801 14.132 15.8801H16.332V13.9002C16.332 13.4249 16.5984 13.1084 16.9984 13.1084H19.3336C19.7336 13.1084 20 13.4249 20 13.9002C20 14.3754 19.7336 14.692 19.3336 14.692H17.6V16.6719C17.6 17.1471 17.3336 17.4637 16.9336 17.4637H14.7336V19.2059C14.8 19.6821 14.4664 19.9996 14.1336 19.9996V19.9996Z"
        fill={fillColor}
      />
      <path
        d="M9.7672 17.4655V16.9657L9.26741 16.9655L7.06661 16.9646H7.0664C7.00865 16.9646 6.98399 16.9466 6.96574 16.9249C6.941 16.8956 6.9 16.8201 6.9 16.6728V14.6929V14.1932L6.40027 14.1929L4.66667 14.192H4.6664C4.60865 14.192 4.58399 14.174 4.56574 14.1523C4.541 14.1229 4.5 14.0475 4.5 13.9002C4.5 13.7529 4.541 13.6774 4.56574 13.648C4.58399 13.6264 4.60865 13.6084 4.6664 13.6084H7.0664C7.12415 13.6084 7.14881 13.6264 7.16706 13.648C7.1918 13.6774 7.2328 13.7529 7.2328 13.9002V15.8801V16.3801H7.7328H9.9328C9.99055 16.3801 10.0152 16.3981 10.0335 16.4197C10.0582 16.4491 10.0992 16.5246 10.0992 16.6719V18.4142V18.9142H10.5992H13.4656H13.9656V18.4142V16.6719C13.9656 16.5246 14.0066 16.4491 14.0313 16.4197C14.0496 16.3981 14.0743 16.3801 14.132 16.3801H16.332H16.832V15.8801V13.9002C16.832 13.7529 16.873 13.6774 16.8977 13.648C16.916 13.6264 16.9407 13.6084 16.9984 13.6084H19.3336C19.3913 13.6084 19.416 13.6264 19.4343 13.648C19.459 13.6774 19.5 13.7529 19.5 13.9002C19.5 14.0475 19.459 14.1229 19.4343 14.1523C19.416 14.174 19.3913 14.192 19.3336 14.192H17.6H17.1V14.692V16.6719C17.1 16.8192 17.059 16.8946 17.0343 16.924C17.016 16.9457 16.9913 16.9637 16.9336 16.9637H14.7336H14.2336V17.4637V19.2059V19.2406L14.2384 19.275C14.2527 19.3776 14.223 19.4329 14.2005 19.4597C14.1721 19.4934 14.1423 19.4996 14.1336 19.4996H13.6336L9.9336 19.4996C9.87585 19.4996 9.85119 19.4816 9.83294 19.4599C9.8082 19.4306 9.7672 19.3551 9.7672 19.2078V17.4655Z"
        stroke="#212121"
        strokeOpacity="0.08"
      />
      <path
        d="M19.3336 14.6923C18.9336 14.6923 18.6672 14.3758 18.6672 13.9006L18.6664 5.58356H5.33358V13.9006C5.33358 14.3758 5.06718 14.6923 4.66718 14.6923C4.26718 14.6923 4.00078 14.3758 4.00078 13.9006L4 4.79178C4 4.31652 4.2664 4 4.6664 4H19.3328C19.7328 4 19.9992 4.31652 19.9992 4.79178V13.9006C20 14.3758 19.7336 14.6923 19.3336 14.6923H19.3336Z"
        fill={fillColor}
      />
      <path
        d="M19.9992 13.9006V4.79178C19.9992 4.31652 19.7328 4 19.3328 4H4.6664C4.2664 4 4 4.31652 4 4.79178L19.9992 13.9006ZM19.9992 13.9006C20 14.3758 19.7336 14.6923 19.3336 14.6923H19.3336C18.9336 14.6923 18.6672 14.3758 18.6672 13.9006H19.9992ZM19.1672 13.9006V13.9005L19.1664 5.58351L19.1663 5.08356H18.6664H5.33358H4.83358V5.58356V13.9006C4.83358 14.0479 4.79258 14.1233 4.76784 14.1527C4.74959 14.1744 4.72493 14.1923 4.66718 14.1923C4.60943 14.1923 4.58477 14.1744 4.56652 14.1527C4.54179 14.1233 4.50078 14.0479 4.50078 13.9006V13.9005L4.5 4.79178C4.5 4.79177 4.5 4.79175 4.5 4.79174C4.50001 4.64445 4.54101 4.56902 4.56574 4.53963C4.58399 4.51795 4.60865 4.5 4.6664 4.5H19.3328C19.3906 4.5 19.4152 4.51795 19.4335 4.53963C19.4582 4.56902 19.4992 4.64446 19.4992 4.79178L19.4992 13.9006L19.4992 13.9014C19.4994 14.0485 19.4586 14.1237 19.434 14.1529C19.4159 14.1744 19.3914 14.1923 19.3336 14.1923H19.3336C19.2758 14.1923 19.2512 14.1744 19.2329 14.1527C19.2082 14.1233 19.1672 14.0479 19.1672 13.9006Z"
        stroke="#212121"
        strokeOpacity="0.08"
      />
      <path
        d="M17.3516 9.11426C16.9014 9.11426 16.6016 8.92574 16.6016 8.64268V7.08584C16.6016 6.80278 16.9014 6.61426 17.3516 6.61426C17.8017 6.61426 18.1016 6.80278 18.1016 7.08584V8.64268C18.1024 8.8782 17.727 9.11426 17.3516 9.11426Z"
        fill={fillColor}
      />
      <path
        d="M17.3516 8.61426C17.2247 8.61426 17.1442 8.59292 17.1016 8.57517V7.15334C17.1442 7.13559 17.2247 7.11426 17.3516 7.11426C17.4784 7.11426 17.5589 7.13559 17.6016 7.15334V8.54349C17.6016 8.54349 17.6015 8.5435 17.6015 8.54351C17.5378 8.58359 17.4419 8.61426 17.3516 8.61426Z"
        stroke="#212121"
        strokeOpacity="0.08"
      />
      <path
        d="M14.6826 9.11426C14.2324 9.11426 13.9326 8.92574 13.9326 8.64268V7.08584C13.9326 6.80278 14.2324 6.61426 14.6826 6.61426C15.1328 6.61426 15.4326 6.80278 15.4326 7.08584V8.64268C15.4326 8.8782 15.1328 9.11426 14.6826 9.11426Z"
        fill={fillColor}
      />
      <path
        d="M14.6826 8.61426C14.5558 8.61426 14.4753 8.59292 14.4326 8.57517V7.15334C14.4753 7.13559 14.5558 7.11426 14.6826 7.11426C14.8095 7.11426 14.8899 7.13559 14.9326 7.15334V8.56097C14.89 8.58489 14.8076 8.61426 14.6826 8.61426ZM14.964 8.53873C14.9641 8.53875 14.9634 8.53964 14.9614 8.54134C14.963 8.53956 14.9639 8.53871 14.964 8.53873Z"
        stroke="#212121"
        strokeOpacity="0.08"
      />
      <path
        d="M12.085 9.11426C11.6348 9.11426 11.335 8.92574 11.335 8.64268V7.08584C11.335 6.80278 11.6348 6.61426 12.085 6.61426C12.5351 6.61426 12.835 6.80278 12.835 7.08584V8.64268C12.835 8.8782 12.5351 9.11426 12.085 9.11426Z"
        fill={fillColor}
      />
      <path
        d="M12.085 8.61426C11.9581 8.61426 11.8776 8.59292 11.835 8.57517V7.15334C11.8776 7.13559 11.9581 7.11426 12.085 7.11426C12.2118 7.11426 12.2923 7.13559 12.335 7.15334V8.56097C12.2923 8.58489 12.21 8.61426 12.085 8.61426ZM12.3664 8.53873C12.3665 8.53875 12.3657 8.53964 12.3638 8.54134C12.3653 8.53956 12.3663 8.53871 12.3664 8.53873Z"
        stroke="#212121"
        strokeOpacity="0.08"
      />
      <path
        d="M9.4834 9.11426C9.03322 9.11426 8.7334 8.92574 8.7334 8.64268V7.08584C8.7334 6.80278 9.03322 6.61426 9.4834 6.61426C9.93358 6.61426 10.2334 6.80278 10.2334 7.08584V8.64268C10.2334 8.8782 9.85883 9.11426 9.4834 9.11426Z"
        fill={fillColor}
      />
      <path
        d="M9.4834 8.61426C9.35654 8.61426 9.27608 8.59292 9.2334 8.57517V7.15334C9.27608 7.13559 9.35654 7.11426 9.4834 7.11426C9.61026 7.11426 9.69071 7.13559 9.7334 7.15334V8.54328C9.73323 8.54339 9.73306 8.54349 9.73289 8.5436C9.66926 8.58364 9.57362 8.61426 9.4834 8.61426Z"
        stroke="#212121"
        strokeOpacity="0.08"
      />
      <path
        d="M6.81826 9.11426C6.36808 9.11426 6.06826 8.92574 6.06826 8.64268L6.06738 7.08584C6.06738 6.80278 6.3672 6.61426 6.81738 6.61426C7.26756 6.61426 7.56738 6.80278 7.56738 7.08584V8.64268C7.56826 8.8782 7.26844 9.11426 6.81826 9.11426H6.81826Z"
        fill={fillColor}
      />
      <path
        d="M6.06738 7.08584C6.06738 6.80278 6.3672 6.61426 6.81738 6.61426C7.26756 6.61426 7.56738 6.80278 7.56738 7.08584V8.64268C7.56826 8.8782 7.26844 9.11426 6.81826 9.11426C6.36808 9.11426 6.06826 8.92574 6.06826 8.64268L6.06738 7.08584ZM6.06738 7.08584L6.56738 7.08556L6.56738 7.08584M6.06738 7.08584H6.56738M6.56738 7.08584C6.56738 7.10714 6.5607 7.13253 6.54785 7.15355C6.54032 7.16588 6.5342 7.171 6.5342 7.171C6.53419 7.171 6.53582 7.16963 6.53971 7.16718C6.54595 7.16326 6.55512 7.15844 6.56742 7.15333M6.56738 7.08584L6.56742 7.15333M6.56742 7.15333C6.61012 7.13558 6.69056 7.11426 6.81738 7.11426C6.94424 7.11426 7.02469 7.13559 7.06738 7.15334M6.56742 7.15333L6.56822 8.57516M7.06738 7.15334V8.56142M7.06738 7.15334C7.07966 7.15845 7.08882 7.16326 7.09505 7.16718C7.09895 7.16963 7.10057 7.171 7.10057 7.171C7.10056 7.171 7.09445 7.16588 7.08691 7.15355C7.07406 7.13253 7.06738 7.10714 7.06738 7.08584V7.15334ZM6.56822 8.57516C6.55596 8.57006 6.54682 8.56525 6.54059 8.56134C6.5367 8.55889 6.53507 8.55752 6.53508 8.55752C6.53508 8.55752 6.5412 8.56264 6.54873 8.57497C6.56153 8.5959 6.5682 8.62115 6.56826 8.64239L6.56822 8.57516ZM6.56822 8.57516C6.6109 8.59291 6.69137 8.61426 6.81826 8.61426C6.94266 8.61426 7.02472 8.58518 7.06738 8.56142M7.06738 8.56142L7.06738 8.64268C7.06758 8.58151 7.08905 8.5503 7.09657 8.54163M7.06738 8.56142C7.07306 8.55826 7.07805 8.55519 7.08234 8.55229C7.08953 8.54744 7.09405 8.54384 7.09657 8.54163M7.09657 8.54163C7.09846 8.53996 7.09922 8.53909 7.09913 8.53907C7.09903 8.53905 7.09808 8.53988 7.09657 8.54163Z"
        stroke="#212121"
        strokeOpacity="0.08"
      />
    </svg>
  )
}
export const UnknownBubble = ({
  isOffline: _isOffline,
  htmlColor,
  'aria-label': ariaLabel,
  ...props
}: {
  isOffline?: boolean
  htmlColor: string
  'aria-label': string
}) => <QuestionMark {...props} fontSize="medium" htmlColor={htmlColor} aria-label={ariaLabel} />
